export class Address {
  private street: string;
  private number: string;
  private complement: string;
  private district: string;
  private city: string;
  private region: string;
  private zipCode: string;
  private isNewAddress: boolean;

  getStreet(): string {
    return this.street;
  }

  setStreet(value: string): void {
    this.street = value;
  }

  getNumber(): string {
    return this.number;
  }

  setNumber(value: string): void {
    this.number = value;
  }

  getComplement(): string {
    return this.complement;
  }

  setComplement(value: string): void {
    this.complement = value;
  }

  getZipCode(): string {
    return this.zipCode;
  }

  setZipCode(value: string): void {
    this.zipCode = value;
  }

  getDistrict(): string {
    return this.district;
  }

  setDistrict(value: string): void {
    this.district = value;
  }

  getCity(): string {
    return this.city;
  }

  setCity(value: string): void {
    this.city = value;
  }

  getRegion(): string {
    return this.region;
  }

  setRegion(value: string): void {
    this.region = value;
  }

  getIsNewAddress(): boolean {
    return this.isNewAddress;
  }

  setIsNewAddress(value: boolean){
    this.isNewAddress = value;
  }
  
}
